import { TimePicker } from '@mui/x-date-pickers'
import { Dayjs } from 'dayjs'
import { FC } from 'react'

interface Props {
  label: string
  onChange: (data: any) => void
  value?: Dayjs | null
  fullWidth?: boolean
  ampm?: boolean
  error?: boolean
  helperText?: React.ReactNode
  required?: boolean
  validate?: () => void
}

export const CustomTimePicker: FC<Props> = ({
  label,
  onChange,
  value,
  fullWidth,
  ampm,
  error,
  helperText,
  required,
  validate,
}) => {
  return (
    <TimePicker
      ampm={ampm}
      value={value}
      label={label}
      onChange={onChange}
      onClose={() => {
        validate?.()
      }}
      sx={{ width: fullWidth ? '100%' : undefined }}
      slotProps={{
        textField: {
          variant: 'outlined',
          helperText: error ? helperText : '',
          error: error,
          sx: { width: '100%' },
          required: required,
          onBlur: () => validate?.(),
        },
      }}
    />
  )
}
